// src/app/components/timezone-select/timezone-select.component.ts
import {Component} from "@angular/core";
import {ModalController} from "@ionic/angular";
import {TIMEZONES} from "../../constants/timezones";


@Component({
  selector: "app-timezone-select",
  templateUrl: "./timezone-select.component.html",
  standalone: false,
})
export class TimezoneSelectComponent {
  public filtered = [...TIMEZONES];
  private all = TIMEZONES;

  constructor(private modalCtrl: ModalController) {
  }

  onSearchChange(ev: CustomEvent) {
    const q = String((ev.detail as any).value || "").toLowerCase();
    this.filtered = this.all.filter(tz => tz.toLowerCase().includes(q));
  }

  pick(tz: string) {
    this.modalCtrl.dismiss(tz, "confirm");
  }

  close() {
    this.modalCtrl.dismiss(null, "cancel");
  }
}
